import archiveDate from './archive-date';
import archiveDownload from './archive-download';
import archiveNumberOfOrders from './archive-orders';
import archiveNumberOfShipments from './archive-shipments';
import archiveOrderTotal from './archive-order-total';
import archiveShippingTotal from './archive-shipping-total';

export default [archiveDate, archiveNumberOfOrders, archiveNumberOfShipments, archiveOrderTotal, archiveShippingTotal, archiveDownload];
